module.exports = __webpack_public_path__ + "img/feat-media.c24fa812.jpg";